import { OmniaModuleId, OmniaObjectType } from "../generated/enums"
import { ClientState } from "../shell"
import { RoleId } from "../user"

/** Describes any generic "change" received by the API */
export interface OmniaApiChange {

    id: number

    source?: OmniaModuleId | "shared" | "refresh" | "refresh-all"

    type?: OmniaObjectType
    action?: string

    data?: any

    url?: string

    local: boolean

}

/** @internal */
export interface HoldingSessions {

    readonly active: HoldingSession[]
    readonly sessions: HoldingSession[]

}

/** @internal */
export interface HoldingSession {

    /** Session id (GUID) */
    SessionId: string

    /** Session type */
    SessionType?: SessionType

    /** True for read-only sessions */
    ReadOnly: boolean

    /** User id */
    UserId: number

    /** Full name of the user (first + last) */
    UserName: string

    /** Email address */
    UserEmail: string

    /** Role (Agronomist, Client, ...) */
    Role: RoleId

    /** Start date/time (UTC) of the session */
    StartDate: Date

    /*
    * If the session is deemed to be inactive,
    * the date/time (UTC) since it has been
    */
    InactiveSince: Date

    /**
     * Provides state information about the client using this session
     * (module being used, resource being edited...)
     */
    ClientState?: ClientState

    /** True if this is the current session */
    CurrentSession?: boolean

    /**
     * This is used to detect potential conflicts between multiple sessions
     * If at least one session has the same ConfliCtId has the current one,
     * this indicates that multiple users have started editing the same record
     * at the same time
     */
    ConflictId?: string

}

/** @internal */
export interface HoldingEvents {

    /**
     * New, "unread" events
     */
    readonly unread: HoldingEvent[]

    /**
     * All events
     */
    readonly events: HoldingEvent[]

}

/** @internal */
export interface OmniaEvent {

    Source: OmniaModuleId
    ObjectType: OmniaObjectType
    Action: string

    Data: any

}

/** @internal */
export interface HoldingEvent extends OmniaEvent {

    /** Event id (globally unique number) */
    Id: number

    /** Session id (GUID) */
    SessionId: string
    /** User id */
    UserId: number

    /** Cropping year (maybe be unset) */
    Year: number

    /** Date/time (UTC) when the event occurred */
    Date: Date

    CurrentSession?: boolean
    UserName?: string
    UserEmail?: string
    Unread?: boolean

}

/** @internal */
export interface HoldingEventUser {
    Id: number,
    FirstName: string,
    LastName: string,
    Email: string
}

/** @internal */
export enum SessionType {
    Omnia = 1,
    Admin = 2,
    Connect = 3,
    FieldScout = 4,
    FieldScoutSync = 5
}
